import Image from 'next/image'
import { useNextLocale } from '@captaincause/lib/useNextLocale'
import { ProjectPage } from '@captaincause/ui/ProjectPage'
import { Button } from 'components/Button'
import type { Campaign, Project } from '@captaincause/types'
import type { ReactNode } from 'react'

export interface MobilePanelContainerProps {
  project: Project
  children: ReactNode
  campaign?: Campaign
}

export function MobilePanelContainer({
  project,
  children,
  campaign = undefined,
}: MobilePanelContainerProps) {
  const locale = useNextLocale()

  return (
    <div data-testid="give-panel-mobile">
      {project.preview_image ? (
        <Image
          src={project.preview_image || ''}
          alt=""
          className="mb-4 h-[224px] w-full max-w-none object-cover"
          width={375}
          height={224}
        />
      ) : null}
      {children}
      <hr className="mx-0 border-medium-gray pb-10" />

      <ProjectPage
        as="div"
        project={project}
        showImages={false}
        showMicroImpact={false}
        showName={false}
        showSimilarProjects={false}
        showOrganizationLogo={false}
        locale={locale}
        Link={Button}
      />
    </div>
  )
}
